import { startLSObserver, startLTObserver } from './utils/observer';

export function startLighthouseObserver(): void {
	startLSObserver();
	startLTObserver();
}
